module.exports = __webpack_public_path__ + "img/email.0f7b76ef.svg";